import { __decorate, __metadata, __param } from "tslib";
import { smoothScroll } from '@gn-audio/ui/tools/smooth-srcoll';
import { element as ngElement } from 'angular';
import { Inject, Injectable } from 'angular-ts-decorators';
var ItemScrollerService = (function () {
    function ItemScrollerService($timeout, hashSeeker) {
        this.$timeout = $timeout;
        this.hashSeeker = hashSeeker;
        this.defaultTimeout = 500;
    }
    ItemScrollerService.prototype.items = function () {
        return this.hashSeeker.items();
    };
    ItemScrollerService.prototype.scrollToItem = function (itemId) {
        var _this = this;
        if (itemId.length === 0) {
            return;
        }
        if (typeof itemId === 'string') {
            this.$timeout(function () {
                var item = document.querySelector("[item-id=\"" + itemId + "\"]");
                _this.scrollTo(item);
            }, this.defaultTimeout);
        }
        else if (typeof itemId === 'object' && itemId instanceof Array) {
            if (itemId.length === 1) {
                this.scrollToItem(itemId[0]);
                return;
            }
            var element_1 = null;
            for (var _i = 0, itemId_1 = itemId; _i < itemId_1.length; _i++) {
                var loopItemId = itemId_1[_i];
                element_1 = ngElement("[item-id=\"" + loopItemId + "\"]", element_1);
            }
            if (element_1 === null || element_1.length === 0) {
                return;
            }
            this.$timeout(function () {
                _this.scrollTo(element_1[0]);
            }, this.defaultTimeout);
        }
    };
    ItemScrollerService.prototype.scrollToSection = function (sectionId) {
        var _this = this;
        this.$timeout(function () {
            var section = document.querySelector('[section-id="' + sectionId + '"]');
            _this.scrollTo(section);
            ngElement(window).trigger('resize');
        }, this.defaultTimeout);
    };
    ItemScrollerService.prototype.section = function () {
        return this.hashSeeker.section();
    };
    ItemScrollerService.prototype.tryScrollToSection = function (sectionId) {
        if (this.hashSeeker.section() !== sectionId) {
            return;
        }
        this.scrollToSection(sectionId);
    };
    ItemScrollerService.prototype.scrollTo = function (element) {
        if (element === null) {
            return;
        }
        smoothScroll(element);
        this.hashSeeker.clear();
    };
    ItemScrollerService.$inject = ['$timeout', 'hashSeeker'];
    ItemScrollerService = __decorate([
        Injectable('itemScroller'),
        __param(0, Inject('$timeout')),
        __param(1, Inject('hashSeeker')),
        __metadata("design:paramtypes", [Function, Object])
    ], ItemScrollerService);
    return ItemScrollerService;
}());
export { ItemScrollerService };
